// extracted by mini-css-extract-plugin
export default {"container":"login_container__VLWLl","card":"login_card__TW6LJ","space":"login_space__cLJSN"};